export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const CREATE = '/create';
export const QUESTIONS = '/questions';
export const SEND = '/send';
export const POLL = '/poll';
export const RESPONSES = '/responses';
export const CONTRATULATIONS = '/congratulations';
export const DONE = '/done';
export const ONBOARDING = '/onboarding';
export const ERROR = '/error';
export const TERMS = '/terms';



// WEBPACK FOOTER //
// ./src/constants/routes.js